const store = new Map();

/**
 * Cache em memória para leituras idempotentes (lista de posts, serviços, etc.).
 * Reduz chamadas repetidas ao Supabase sob pico de tráfego na mesma sessão/CDN edge.
 */
export function cachedQuery(key, ttlMs, fetcher) {
  const hit = store.get(key);
  const now = Date.now();

  if (hit) {
    if (hit.data !== undefined && now < hit.expires) {
      return Promise.resolve(hit.data);
    }
    if (hit.promise && now < hit.expires) {
      return hit.promise;
    }
  }

  const promise = Promise.resolve()
    .then(fetcher)
    .then((data) => {
      store.set(key, { data, expires: Date.now() + ttlMs });
      return data;
    })
    .catch((err) => {
      store.delete(key);
      throw err;
    });

  store.set(key, { promise, expires: now + ttlMs });
  return promise;
}

export function invalidateQuery(key) {
  store.delete(key);
}

export function invalidateQueryPrefix(prefix) {
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) store.delete(key);
  }
}
